import React, { useEffect, useState } from "react";
import { CircularProgress, useMediaQuery } from "@mui/material";
import ProductCard from "../ProductCard/ProductCard";
import { Product } from "../../types/Product";
import { HttpCategoryProduct } from "../../http";
import { Icon, SectionHeader } from "../liquid/LiquidPrimitives";

interface RelatedProductsCarouselProps {
    currentProductId?: string;
    categoryId?: string;
    relatedProductsAmount?: number;
}

const RelatedProductsCarousel: React.FC<RelatedProductsCarouselProps> = ({
    currentProductId,
    categoryId,
    relatedProductsAmount = 8,
}) => {
    const [relatedProducts, setRelatedProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);
    const isMobile = useMediaQuery("(max-width:768px)");

    useEffect(() => {
        const fetchRelatedProducts = async () => {
            try {
                setLoading(true);
                if (categoryId) {
                    const productsData = await HttpCategoryProduct.getProductsByCategoryId(
                        categoryId,
                        1,
                        relatedProductsAmount,
                    );
                    setRelatedProducts(
                        productsData.paginaProductosDTO.lista.filter(
                            (product) => product.id !== currentProductId,
                        ),
                    );
                } else {
                    setRelatedProducts([]);
                }
            } catch (error) {
                console.error("Error fetching related products:", error);
                setRelatedProducts([]);
            } finally {
                setLoading(false);
            }
        };

        fetchRelatedProducts();
    }, [currentProductId, categoryId, relatedProductsAmount]);

    if (loading) {
        return (
            <section
                style={{ marginTop: 80, display: "flex", justifyContent: "center", padding: 48 }}
            >
                <CircularProgress size={24} sx={{ color: "var(--ink-900)" }} />
            </section>
        );
    }

    if (relatedProducts.length === 0) {
        return null;
    }

    return (
        <section style={{ marginTop: 80 }}>
            <SectionHeader
                eyebrow="Tambien te puede gustar"
                title="Productos relacionados"
                action={
                    <a className="pill" href="/productos">
                        Ver mas <Icon.arrowUpRight />
                    </a>
                }
            />
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)",
                    gap: 18,
                }}
            >
                {relatedProducts.slice(0, 4).map((product) => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>
        </section>
    );
};

export default RelatedProductsCarousel;
